<template>
  <q-layout data-testid="annual-weighing-report" class="q-pa-lg">
    <q-card class="fit">
      <q-card-section class="q-py-xs">
        <div class="report-title">
          {{ reportTitle }}
        </div>
      </q-card-section>
      <q-card-section class="q-py-md q-px-lg full-height">
        <q-form @submit.prevent="generateReport" class="q-gutter-md q-form">
          <div class="row justify-center q-col-gutter-md no-wrap">
            <div class="col-12 col-md-4">
            <q-input
                v-model="form.inputInitial"
                :label="$gettext('Data Inicial *')"
                mask="##/##/####"
                outlined
                required
                :rules="[dateValidationRule]"
                lazy-rules
            >
                <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy
                    ref="datePopupInitial"
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                    >
                    <q-date
                        v-model="form.inputInitial"
                        mask="DD/MM/YYYY"
                        @input="onInitialDateSelect"
                    >
                        <div class="row items-center justify-end">
                        <q-btn v-close-popup label="Close" color="primary" flat />
                        </div>
                    </q-date>
                    </q-popup-proxy>
                </q-icon>
                </template>
            </q-input>
            </div>

            <div class="col-12 col-md-4">
                <q-input
                    v-model="form.inputFinal"
                    :label="$gettext('Data Final *')"
                    mask="##/##/####"
                    outlined
                    required
                    lazy-rules
                >
                    <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                        ref="datePopupFinal"
                        cover
                        transition-show="scale"
                        transition-hide="scale"
                        >
                        <q-date
                            v-model="form.inputFinal"
                            mask="DD/MM/YYYY"
                            @input="onFinalDateSelect"
                        >
                            <div class="row items-center justify-end">
                            <q-btn v-close-popup label="Close" color="primary" flat />
                            </div>
                        </q-date>
                        </q-popup-proxy>
                    </q-icon>
                    </template>
                </q-input>
            </div>

            <div class="col-12 col-md-2">
              <q-select
                emit-value
                map-options
                outlined
                v-model="form.landfill"
                :options="comboLandfill"
                :label="$gettext('Aterro')"
                :loading="loadingLandfill"
                @input="changeLandfill"
                option-value="value"
                option-label="label"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      <translate>NO_RESULT</translate>
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>
          </div>
          <div class="row justify-center q-col-gutter-md no-wrap">
            <div class="col-12 col-md-5">
              <q-select
                emit-value
                map-options
                outlined
                v-model="form.technologies"
                use-chips
                multiple
                @clear="loadResidues"
                :options="comboTreatmentType"
                :label="$gettext('TECHNOLOGY')"
                :loading="loadingTechnology"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      <translate>NO_RESULT</translate>
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>

            <div class="col-12 col-md-5">
              <q-select
                emit-value
                map-options
                outlined
                v-model="form.residues"
                :options="filteredComboResidue"
                use-chips
                multiple
                @clear="loadTechnologies"
                @blur="reloadTechnologies"
                :label="$gettext('RESIDUE_SINGULAR')"
                use-input
                input-debounce="300"
                @filter="filterResidues"
                clearable
                :loading="loadingResidue"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      <translate>NO_RESULT</translate>
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>
          </div>
          <br />
          <div class="row justify-center q-col-gutter-md no-wrap">
            <div class="col-12 col-md-3">
              <q-select
                emit-value
                map-options
                outlined
                v-model="form.clientType"
                :options="clientTypeOptions"
                :label="$gettext('Tipo Cliente')"
                @input="changeClientType"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      <translate>NO_RESULT</translate>
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>
            <div class="col-12 col-md-7">
                      <q-select
                        emit-value
                        map-options
                        outlined
                        v-model="form.clients"
                        :options="filteredComboClient"
                        :label="$gettext('Cliente')"
                        :loading="loadingClient"
                        option-value="value"
                        option-label="label"
                        use-chips
                        multiple
                        use-input
                        input-debounce="300"
                        @filter="filterClients"
                        clearable
                      >
                        <template v-slot:no-option>
                          <q-item>
                            <q-item-section class="text-grey">
                              <translate>NO_RESULT</translate>
                            </q-item-section>
                          </q-item>
                        </template>
                      </q-select>
            </div>
          </div>
        </q-form>
      </q-card-section>
      <br />
    </q-card>

    <div class="row full-width q-col-gutter-lg justify-center q-py-md">
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="onClear">
          {{ $gettext('CLEAN') }}
        </q-btn>
      </div>
      <div class="col-lg-2 col-md-3">
        <q-btn
          class="full-width"
          color="info"
          @click="generateReport"
          :loading="loadingReport"
          :disable="!isValidDates"
        >
          {{ $gettext('GENERATE') }}
        </q-btn>
      </div>
    </div>
  </q-layout>
</template>

<script>
import { Vue, Component, Watch } from 'vue-property-decorator'
import { JtMonthPicker, JtDatetime, JtSelect } from 'jtech-webcomps'
import { JtDocsViewer } from 'jtech-webcomps/src/components/jtech-docs'
import { repository, messageBox } from 'jtech'
import moment from 'moment'

@Component({
  name: 'AnnualWeighingFilter',
  components: {
    JtMonthPicker,
    JtDatetime,
    JtSelect,
    JtDocsViewer
  },
  props: {
    value: {
      required: true
    },
    navigationMaxYearMonth: {
      type: String
    },
    navigatorMinYearMonth: {
      type: String
    }
  }
})
class AnnualWeighingFilter extends Vue {
  fileSrc = null
  reportTitle = 'Relatório Anual de Pesagens'
  loadingReport = false
  loadingLandfill = false

  reportGenerationFormat = {
    online: true,
    scheduling: false
  }

  reportFormat = {
    pdf: false,
    xls: true
  }

  // Formulário com datas e filtros
  form = {
    inputInitial: null,
    inputFinal: null,
    landfill: null,
    technologies: [],
    residues: [],
    clientType: null,
    clients: []
  }

  comboTreatmentType = []
  comboResidues = []
  filteredComboResidue = []
  comboLandfill = []
  comboClient = []
  filteredComboClient = []
  loadingClient = false
  loadingResidue = false
  loadingTechnology = false
  clientTypeOptions = [
    { label: 'Público', value: 20060001 },
    { label: 'Privado', value: 20060002 },
    { label: 'Misto', value: 20060003 }
  ]

  selected = { year: false, month: false };

  get eventMaxYearMonth () {
    return this.validateDate(this.navigationMaxYearMonth)
  }

  get eventMinYearMonth () {
    return this.validateDate(this.navigatorMinYearMonth)
  }

  validateDate (value) {
    if (!value || value.length !== 7) {
      return ''
    } else {
      const numbers = value.split('/')
      return numbers[1] + '-' + numbers[0] + '-01'
    }
  }

  dateValidationRule = (val) => {
    if (!val) return this.$gettext('Campo obrigatório')

    // Verificar formato com moment
    const momentDate = moment(val, 'DD/MM/YYYY', true)

    if (!momentDate.isValid()) {
      return this.$gettext('Formato de data inválido!')
    }

    return true
  }

  finalDateValidationRule = (val) => {
    if (!val || !this.form.inputInitial) return true

    const initialMoment = moment(this.form.inputInitial, 'DD/MM/YYYY', true)
    const finalMoment = moment(val, 'DD/MM/YYYY', true)

    if (!initialMoment.isValid() || !finalMoment.isValid()) return true

    if (finalMoment.isBefore(initialMoment)) {
      return this.$gettext('Data final deve ser maior que a data inicial')
    }

    return true
  }

  onInitialDateSelect (value) {
    this.$refs.datePopupInitial.hide()
  }

  onFinalDateSelect (value) {
    this.$refs.datePopupFinal.hide()
  }

  // Computed properties
  get isValidDates () {
    return this.form.inputInitial && this.form.inputFinal
  }

  get formatPeriod () {
    return `${this.$gettext('OF_UPPER_CASE')} ${this.form.inputInitial} ${this.$gettext('TO_IN_UPPER_CASE')} ${this.form.inputFinal}`
  }

  // Métodos
  async generateReport () {
    if (!this.isValidDates) {
      messageBox.error(this.$gettext('DATA_INTERVAL_REQUIRED'))
      return
    }

    // Validar se a data final é maior que a inicial
    const inputDate = new Date(this.parseDate(this.form.inputInitial))
    const outputDate = new Date(this.parseDate(this.form.inputFinal))

    this.loadingReport = true

    try {
      const params = this.createParamsReport()
      const reportData = await repository.resolveLogic('annualWasteWeighingReport.annualWasteWeighingReport', params)
      await this.__whenGenerationFormatIsOnline(reportData)
    } catch (error) {
      this.loadingReport = false
    } finally {
      this.loadingReport = false
    }
  }

  createParamsReport () {
    // Extrair ano da data inicial para usar como base
    const inputYear = new Date(this.parseDate(this.form.inputInitial)).getFullYear()

    return {
      cdRelatorio: 'annualWasteWeighingReport',
      relFormaGeracao: 1, // Online
      relFormatoRelatorio: 3, // XLS
      landfillId: this.form.landfill,
      treatmentType: this.form.technologies && this.form.technologies.length > 0 ? this.form.technologies : null,
      residue: this.form.residues && this.form.residues.length > 0 ? this.form.residues : null,
      inputYear: inputYear,
      clientType: this.form.clientType && this.form.clientType.length > 0 ? this.form.clientType : null,
      client: this.form.clients && this.form.clients.length > 0 ? this.form.clients : null, // ← clients, não client
      inputDateInicial: this.convertToServerFormat(this.form.inputInitial),
      inputDateFinal: this.convertToServerFormat(this.form.inputFinal)
    }
  }

  convertToServerFormat (dateString) {
    if (!dateString) return null

    // Converter de DD/MM/YYYY para YYYY-MM-DD
    const parts = dateString.split('/')
    const day = parts[0]
    const month = parts[1]
    const year = parts[2]

    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
  }

  parseDate (dateString, time = '') {
    if (!dateString) {
      return null
    }
    const parts = dateString.split('/')
    const day = parseInt(parts[0], 10)
    const month = parseInt(parts[1], 10)
    const year = parseInt(parts[2], 10)
    return new Date(year, month - 1, day) // month é 0-indexed no JavaScript
  }

  onClear () {
    this.form.inputInitial = null
    this.form.inputFinal = null
    this.form.technologies = []
    this.form.residues = []
    this.form.clients = []
    this.form.clientType = null
    this.filteredComboResidue = []
    this.filteredComboClient = []
    this.$forceUpdate()
  }

  emitCloseToBus () {
    this.$emit('on-close', {})
  }

  async __whenGenerationFormatIsOnline ({ nmArquivo }) {
    try {
      const result = await this.$jt.repository.downloadFile(
        nmArquivo,
        'xls',
        '',
        'application/xls'
      )

      this.fileSrc = URL.createObjectURL(result)
      this.$nextTick(() => {
        if (this.reportFormat.xls) {
          this.__downloadFile(this.fileSrc, this.reportTitle, '.xls')
          this.emitCloseToBus()
        } else {
          this.$refs.reportModal.show()
        }
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  __downloadFile (fileSrc, fileName = 'downloaded_file', extension = '.xls') {
    const link = document.createElement('a')
    link.style = 'display: none'
    link.download = `${fileName}${extension}`
    link.href = fileSrc
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  async mounted () {
    window.addEventListener('organizational-structure-changed', this.handleOrganizationalStructureChange)
    this.onClear()
    await this.loadLandfills()
    await this.loadTechnologies()
    await this.loadResidues()
    await this.loadActiveClients()
  }

  async changeLandfill () {
    window.addEventListener('organizational-structure-changed', this.handleOrganizationalStructureChange)
    this.onClear()
    await this.loadTechnologies()
    await this.loadResidues()
    await this.loadActiveClients()
  }

  async changeClientType () {
    window.addEventListener('organizational-structure-changed', this.handleOrganizationalStructureChange)
    this.form.clients = []
    await this.loadActiveClients()
  }

  beforeDestroy () {
    // Limpar listener para evitar memory leaks
    window.removeEventListener('organizational-structure-changed', this.handleOrganizationalStructureChange)
  }

  handleOrganizationalStructureChange = async (event) => {
    setTimeout(async () => {
      await this.loadLandfills()
      await this.changeLandfill()
    }, 500)
  }

  async loadTechnologies () {
    this.loadingTechnology = true
    try {
      const techCombo = await repository.resolveLogic('annualWasteWeighingReport.getAllTreatmentTypeByLandfill', { landfill: this.form.landfill })

      // Verificar estrutura da resposta
      if (techCombo && techCombo[0] && techCombo[0].relacionamentos && techCombo[0].relacionamentos.obterTodosExcetoAterro) {
        this.comboTreatmentType = techCombo[0].relacionamentos.obterTodosExcetoAterro
      } else if (techCombo && techCombo.registros) {
        this.comboTreatmentType = techCombo.registros
      } else {
        this.comboTreatmentType = []
      }
    } catch (error) {
      this.comboTreatmentType = []
    } finally {
      this.loadingTechnology = false
    }
  }

  @Watch('form.technologies')
  onTechnologiesChange () {
    this.reloadResidues()
  }

  /*
  @Watch('form.residues')
  onResiduesChange () {
    this.reloadTechnologies()
  } */

  async loadLandfills () {
    this.loadingLandfill = true
    try {
      const response = await repository.resolveLogic('annualWasteWeighingReport.getAllActiveLandfill')
      if (response && response.registros) {
        this.comboLandfill = response.registros
      } else if (Array.isArray(response)) {
        this.comboLandfill = response
      } else {
        this.comboLandfill = []
      }

      if (this.comboLandfill.length > 0) {
        this.form.landfill = this.comboLandfill[0].value
      }
    } catch (error) {
      this.comboLandfill = []
    } finally {
      this.loadingLandfill = false
    }
  }

  async loadResidues () {
    this.loadingResidue = true

    try {
      const response = await repository.resolveLogic('annualWasteWeighingReport.getAllResidueByLandfill', { landfill: this.form.landfill })

      if (response && response.registros) {
        this.comboResidues = response.registros
      } else if (Array.isArray(response)) {
        this.comboResidues = response
      } else {
        this.comboResidues = []
      }
      this.filteredComboResidue = [...this.comboResidues]
    } catch (error) {
      this.comboResidues = []
      this.filteredComboResidue = []
    } finally {
      this.loadingResidue = false
    }
  }

  async reloadResidues () {
    try {
      if (this.form.technologies.length > 0) {
        // Guardar os resíduos atualmente selecionados
        const currentSelectedResidues = [...this.form.residues]

        const objectToSend = this.form.technologies.map(e => { return { treatmentType: e } })

        if (objectToSend.length == 0) {
          this.filteredComboResidue = []
          this.form.residues = []
          return
        }

        // Buscar os novos resíduos disponíveis
        const response = await repository.resolveLogic('annualWasteWeighingReport.getResiduesByTreatmentType', { treatmentType: objectToSend, landfill: this.form.landfill })
        if (response && response.registros) {
          this.comboResidues = response.registros
          this.filteredComboResidue = response.registros

          // Filtrar os resíduos selecionados para manter apenas os que ainda estão disponíveis
          const availableResidueValues = response.registros.map(residue => residue.value)
          this.form.residues = currentSelectedResidues.filter(selectedResidue =>
            availableResidueValues.includes(selectedResidue)
          )
        } else {
          this.comboResidues = []
          this.filteredComboResidue = []
          this.form.residues = []
        }
      } else {
        await this.loadResidues()
      }
      this.$forceUpdate()
    } catch (error) {
      this.comboResidues = []
      this.form.residues = []
    }
  }

  async reloadTechnologies () {
    try {
      if (this.form.residues.length > 0) {
        // Guardar as tecnologias atualmente selecionadas
        const currentSelectedTechnologies = [...this.form.technologies]

        const objectToSend = this.form.residues.map(e => { return { residue: e } })

        if (objectToSend.length == 0) {
          // Se não há resíduos selecionados, manter todas as tecnologias disponíveis
          return
        }

        // Buscar as tecnologias disponíveis baseadas nos resíduos selecionados
        const response = await repository.resolveLogic('annualWasteWeighingReport.getTreatmentTypesByResidues', { residue: objectToSend, landfill: this.form.landfill })

        if (response && response.registros) {
          this.comboTreatmentType = response.registros
          // Filtrar as tecnologias selecionadas para manter apenas as que ainda estão disponíveis
          const availableTechnologyValues = response.registros.map(tech => tech.value)
          this.form.technologies = currentSelectedTechnologies.filter(selectedTech =>
            availableTechnologyValues.includes(selectedTech)
          )
        }
      } else {
        await this.loadTechnologies()
      }
    } catch (error) {
      console.error('Erro ao carregar tecnologias por resíduo:', error)
    }
  }

  filterClients (searchTerm, update, abort) {
    // Salvar o termo de busca para mostrar na mensagem de "não encontrado"
    this.clientSearchTerm = searchTerm

    update(() => {
      if (searchTerm === '') {
        this.filteredComboClient = this.comboClient
      } else {
        const needle = searchTerm.toLowerCase()
        this.filteredComboClient = this.comboClient.filter(client => {
          const nameMatch = client.label && client.label.toLowerCase().includes(needle)
          const documentMatch = client.document && client.document.toLowerCase().includes(needle)
          const valueMatch = client.value && client.value.toString().toLowerCase().includes(needle)

          return nameMatch || documentMatch || valueMatch
        })
      }
    })
  }

  filterResidues (searchTerm, update, abort) {
    // Salvar o termo de busca para mostrar na mensagem de "não encontrado"
    this.residueSearchTerm = searchTerm

    update(() => {
      if (searchTerm === '') {
        this.filteredComboResidue = this.comboResidues
      } else {
        const needle = searchTerm.toLowerCase()
        this.filteredComboResidue = this.comboResidues.filter(residue => {
          const nameMatch = residue.label && residue.label.toLowerCase().includes(needle)
          const valueMatch = residue.value && residue.value.toString().toLowerCase().includes(needle)
          return nameMatch || valueMatch
        })
      }
    })
  }

  async loadActiveClients () {
    this.loadingClient = true
    try {
      const response = await repository.resolveLogic('annualWasteWeighingReport.getAllActiveClientWithDocumentByLandfill', { landfill: this.form.landfill, clientType: this.form.clientType })

      // Verificar estrutura da resposta e adaptar conforme necessário
      if (response && response.registros) {
        this.comboClient = response.registros
      } else if (Array.isArray(response)) {
        this.comboClient = response
      } else {
        this.comboClient = []
      }
      this.filteredComboClient = [...this.comboClient]
    } catch (error) {
      this.comboClient = []
      this.filteredComboClient = []
      messageBox.error(this.$gettext('ERROR_LOADING_CLIENTS'))
    } finally {
      this.loadingClient = false
    }
  }
}

export default AnnualWeighingFilter
</script>

<style scoped>
.report-title {
  font-weight: 500;
  font-size: 1.3em;
  margin-top: 5px;
  border-bottom: 1px solid #e0e0e0;
}

.period-display {
  background-color: #f5f5f5;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.q-form {
  margin-top: 18px;
}
.q-chip__icon--remove[aria-hidden="true"] {
  aria-hidden: false !important;
}

.q-chip .q-chip__icon--remove {
  aria-hidden: false !important;
}
</style>
